<template>
	<v-container fluid>
		<v-dialog  
			v-model="dialog" 
			width = "800"
		>
			<v-card outlined>
				<v-card-title
					class="body-2 pa-1 secondary"
				>
				<v-icon 
					x-small					
					icon
					v-text="'mdi-cog'"
				></v-icon>
				<span
					v-text="'Avanced settings'"
					class=" ml-1 "
				></span>
				</v-card-title
				<v-card-text>
					
				</v-card-text>
				<v-card-actions>
					<input_fields
						key="settings_streams"
					></input_fields>
				</v-card-actions>
			</v-card>	
		</v-dialog>
	</v-container>
</template>
<script>
	import default_setting_field from '@/components/stream/default_setting.json'
	import input_fields from '@/components/info/input_fields.vue'
	export default{
		name: 'settings_stream',
		components:{
			input_fields
		}, // components
		props: [],
		data: () => ({
			dialog: true,
			inf_to_fields: default_setting_field,
			inf: {
					
			},

		}), // data
	};
</script>